import { Card, CardContent, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { LabelField } from 'components'
import { ClusterShipperDto } from 'dtos/clusterShipperDto'
import { formatDate } from 'utils'

interface ClusterShippersListCardProps {
  clusterShipper: ClusterShipperDto
}

export default function ClusterShippersListCard({
  children,
  clusterShipper
}: React.PropsWithChildren<ClusterShippersListCardProps>) {
  return (
    <>
      <Card>
        <CardContent>
          <Grid container direction='row' alignItems='flex-start' spacing={2}>
            <Grid item xs={12} md={6}>
              <Grid container spacing={2}>
                <Grid item xs={12} container alignItems='center' justifyContent='space-between'>
                  <Grid item xs={4}>
                    <LabelField label='Cluster Shipper#' value={clusterShipper.clusterShipperNumber} />
                  </Grid>
                  <Grid item xs={8} sm='auto'>
                    {children}
                  </Grid>
                </Grid>

                <Grid item xs={12}>
                  <LabelField label='Cluster Conversion Company' value={clusterShipper.clusterConversionCompany?.name} />
                </Grid>

                <Grid item xs={12}>
                  <LabelField label='Exporter' value={clusterShipper.exporterCompany?.name} />
                </Grid>

                <Grid item xs={12}>
                  <LabelField label='Buyer' value={clusterShipper.buyerCompany?.name} />
                </Grid>

                <Grid item xs={12}>
                  <LabelField
                    label='Drop Off Date'
                    value={clusterShipper.dropOffDate ? formatDate(clusterShipper.dropOffDate) : ''}
                  />
                </Grid>

                <Grid item xs={12}>
                  <LabelField
                    label='Cluster Conversions Completed'
                    value={
                      clusterShipper.clusterConversionsCompletedDate
                        ? formatDate(clusterShipper.clusterConversionsCompletedDate)
                        : ''
                    }
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} md={6} container alignItems='flex-start'>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>VIN</TableCell>

                      <TableCell>Year</TableCell>

                      <TableCell>Make</TableCell>

                      <TableCell>Model</TableCell>

                      <TableCell>Importer Stock#</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {clusterShipper.vehicles?.map((vehicle, index) => (
                      <TableRow key={vehicle.vin} sx={{ backgroundColor: index % 2 === 0 ? '#FCFCFD' : 'white' }}>
                        <TableCell sx={{ borderBottom: index === (clusterShipper.vehicles?.length ?? 0) - 1 ? 'none' : '' }}>
                          {vehicle.vin}
                        </TableCell>

                        <TableCell sx={{ borderBottom: index === (clusterShipper.vehicles?.length ?? 0) - 1 ? 'none' : '' }}>
                          {vehicle.year}
                        </TableCell>

                        <TableCell sx={{ borderBottom: index === (clusterShipper.vehicles?.length ?? 0) - 1 ? 'none' : '' }}>
                          {vehicle.make}
                        </TableCell>

                        <TableCell sx={{ borderBottom: index === (clusterShipper.vehicles?.length ?? 0) - 1 ? 'none' : '' }}>
                          {vehicle.model}
                        </TableCell>

                        <TableCell sx={{ borderBottom: index === (clusterShipper.vehicles?.length ?? 0) - 1 ? 'none' : '' }}>
                          {vehicle.importerStockNumber}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  )
}
